export const environment = {
  production: false,
  timezone: 'GMT',
  validQualifiers: ['DJCTQ'],
  langFilters: ['pt','pt-br','en'],
  defaultLang: 'pt',
  apiUrl: 'https://siu0pyzvs7.execute-api.us-west-2.amazonaws.com/api',
};
